<script setup>
import { useStore } from '@/wrappers/store'

import DemandSelectTemplate from './DemandSelectTemplate.vue'

const { mapActions } = useStore()
const { fetchDemands, searchDisease } = mapActions('pillars/demands')

const props = defineProps({
  id: {
    type: String,
    default: 'demand-dropdown'
  },
  placeholder: {
    type: String,
    default: 'Demandas relacionadas ao membro'
  },
  value: {
    type: Object,
    default: undefined
  },
  disabled: {
    type: Boolean
  },
  enableHealthCondition: {
    type: Boolean
  }
})

const emit = defineEmits(['input'])
</script>

<template>
  <DemandSelectTemplate
    :id="props.id"
    :placeholder="props.placeholder"
    :value="props.value"
    :disabled="props.disabled"
    :enable-health-condition="props.enableHealthCondition"
    :search-function="searchDisease"
    :fetch-function="fetchDemands"
    @input="emit('input', $event)"
  />
</template>

<style lang="scss" scoped>
.demand-select {
  &__divider {
    letter-spacing: var(--gl-letter-spacing-rule-02);
    font-weight: var(--gl-font-weight-regular);
    font-size: var(--gl-font-size-xxxs);
    line-height: var(--gl-line-height-xxxs);
    color: var(--gl-color-shades-gray-60);
  }
}
</style>
